import { AdminService } from './../../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-question-template-index',
  templateUrl: './question-template-index.component.html',
  styleUrls: ['./question-template-index.component.css']
})
export class QuestionTemplateIndexComponent implements OnInit {
  taskTemplates =[]
  dtOptions: DataTables.Settings = {};

  constructor(
    private adminService:AdminService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
    this.adminService.getTaskTemplates().subscribe(
      x=>{
        this.taskTemplates=[{},...x]
      }
    )

  }

}
